import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import { registerReactComponent } from '@trp-beacon-ui-kit/foundation/react/register';

// This is the name of your project
const projectNamePrefix = 'profile-spa';

//components
export const ProfileBeaconButton = registerReactComponent(
  projectNamePrefix,
  'BeaconButton'
);
export const ProfileBeaconInputField = registerReactComponent(
  projectNamePrefix,
  'BeaconInputField'
);
export const ProfileBeaconDropdown = registerReactComponent(
  projectNamePrefix,
  'BeaconDropdown'
);
export const ProfileBeaconCheckbox = registerReactComponent(
  projectNamePrefix,
  'BeaconCheckbox'
);
export const ProfileBeaconDatePicker = registerReactComponent(
  projectNamePrefix,
  'BeaconDatePicker'
);
export const ProfileBeaconTooltip = registerReactComponent(
  projectNamePrefix,
  'BeaconTooltip'
);
export const ProfileBeaconPopover = registerReactComponent(
    projectNamePrefix,
    'BeaconPopover'
);
export const ProfileBeaconError = registerReactComponent(
  projectNamePrefix,
  'BeaconError'
);
export const ProfileBeaconRadioGroup = registerReactComponent(
  projectNamePrefix,
  'BeaconRadioGroup'
);
export const ProfileBeaconRadioButton = registerReactComponent(
  projectNamePrefix,
  'BeaconRadioButton'
);
export const ProfileBeaconModal = registerReactComponent(
  projectNamePrefix,
  'BeaconModal'
);

export const ProfileBeaconTable = registerReactComponent(
    projectNamePrefix,
    'BeaconTable'
);

export const ProfileBeaconTableHeader = registerReactComponent(
    projectNamePrefix,
    'BeaconTableHeader'
);

export const ProfileBeaconTableRecord = registerReactComponent(
    projectNamePrefix,
    'BeaconTableRecord'
);
